import React, { useState, useEffect } from 'react';

import Note from '../../../components/note';
import Label from '../../../components/label';
import FilterButton from '../../../components/filter-button';
import LinkButton from '../../../components/link-button';
import { getData } from '../../../helper/request-response';
import constant from '../../../config/constant';
import designationPath from './config';

const List = () => {

    const [designations, setDesignations] = useState([]);

    const [designationFilter, setFilterDesignation] = useState({
        name: "",
        isActive: 1
    });

    const getDetailPath = (id) => designationPath.detailPath.replace(":id", id);

    const onFilterChange = e => {

        const { name, value } = e.target;

        setFilterDesignation(filter => ({ 
            ...filter,
            [name]: value
        }));
    };

    const onActiveChange = e => {

        setFilterDesignation(filter => ({ 
            ...filter,
            isActive: filter.isActive === 1 ? 0 : 1
        }));
    };

    const onSubmit = e => {

        e.preventDefault();

        const params = { 
            params: { 
                name: designationFilter.name, 
                'is-active': designationFilter.isActive 
            }
        };

        getDesignations(params);

    };

    const getDesignations = async(params) => {

        const result = await getData(designationPath.baseApi, params);
        
        setDesignations(result);

    }

    const onReset = e => {

        e.preventDefault();

        setFilterDesignation({ 
            ...designationFilter,
            name: "",
            isActive: 1
        });

        getDesignations();

    }

    useEffect(() => { getDesignations() }, []);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{designationPath.title}</h3>
            </div>
            <div className="card-body">

                <div className="row">
                    <div className="col-md-8 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) } >
                            <div className="form-group row">
                                <Label htmlFor="designation-name" isCol={ true } text="Nama Jabatan" />
                                <div className="col-md-9">
                                    <input 
                                        id="designation-name" 
                                        type="text" 
                                        className="form-control"
                                        name="name"
                                        value={designationFilter.name}
                                        onChange={ e => onFilterChange(e) } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } text="Status" />
                                <div className="col-md-9">
                                    <div className="custom-control custom-checkbox">
                                        <input 
                                            id="is-active"
                                            type="checkbox"
                                            className="custom-control-input"
                                            name="isActive"
                                            value={ designationFilter.isActive }
                                            checked={ designationFilter.isActive }
                                            onChange={ e => onActiveChange(e) } />   
                                        <label htmlFor="is-active" className="custom-control-label">Aktif</label>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } />
                                <div className="col-md-9">
                                    <FilterButton to={ designationPath.newPath } newLabel="Tambah Jabatan Baru" onClick={ onReset } />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="col-md-4">
                        <Note isFilter={ true } label="Tambah Jabatan Baru" entity="Jabatan" />
                    </div>
                </div>

                <br />

                <div className="row">

                </div>
                        

                <div className="col-lg-12 mb-4">
                    <div className="row">
                        <div className="table-responsive">
                            <table className="table table-striped table-hover card-text">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nama Jabatan</th>
                                        <th>Status Jabatan</th>
                                        <th>Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        designations.map((designation, index) => {
                                            return(
                                                <tr key={index}>
                                                    <th scope="row">{ index + 1 }</th>
                                                    <td>{ designation.name }</td>
                                                    <td>{ designation.isActive === 1 ? constant.ACTIVE : constant.INACTIVE }</td>
                                                    <td><LinkButton to={ {pathname: getDetailPath(designation.id), state: designation} } /></td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default List;
